export default __webpack_public_path__ + "static/media/red-no-logo.ab5c77fa.png";